<template>
  <div class="card">
    <div class="card-body" ref="searchBox">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1>수강반별 성적표</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableData.length}}</span></strong> 건
        </div>
      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model.trim="search.search_text" @keyup.enter="retrieve" placeholder="클래스명 / 담당 선생님">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>
    </div>

    <!-- 그리드 -->
    <stone-data-table
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="defaultTableProps"
      @row-click="rowClickHandler">
    </stone-data-table>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M060201',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      tableColumns: [
        {label: 'No', prop: 'rnum', align: 'left', width: 60, sortable: false},
        // {label: '클래스 번호', prop: 'class_seq', align: 'left', width: 100},
        {label: '클래스명', prop: 'class_name', align: 'left', width: 350},
        {label: '과목', prop: 'cate_name', align: 'left', width: 150},
        {label: '담당 선생님', prop: 'class_manager_name', align: 'left', width: 150},
        {label: '수강인원', prop: 'class_user_cnt', align: 'right', width: 100},
        {label: '사용구분', prop: 'use_yn_name', align: 'center', width: 100}
      ],
      actionCol: {
        label: '복사',
        props: {
          align: 'center'
        },
        buttons: [{
          handler: row => {
            this.copyClassHandler(row)
          },
          props: {
            icon: 'el-icon-document',
            popover: this.$refs.popover5
          }
        }]
      },
      search: {
        search_text: '',
        class_name: ''
      }
    }
  },
  created () {
    this.retrieve()
  },
  methods: {
    retrieve () {
      this.loadStoneDataTable('/class/list', this.search)
        .then(response => {
          this.tableData = response.data
        })
    },
    goEdit (classSeq) {
      const param = {
        class_seq: classSeq
      }
      this.$router.push({name: 'M060202', params: param})
    },
    rowClickHandler (row, event, column) {
      this.goEdit(row.class_seq)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M060201.vue